var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIconModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    transform: "translate(-954 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(954 349)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(969 364)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M24.458,1.415a1,1,0,0,1,1.711,0l23.54,38.92a1,1,0,0,1-.856,1.518H1.774a1,1,0,0,1-.856-1.518Z",
    transform: "translate(988.524 380.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(833.311 132.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M157.7,292.58a3.386,3.386,0,0,1-2.834-5.127L177.7,248.6a3.263,3.263,0,0,1,5.663-.005l22.833,38.856a3.384,3.384,0,0,1-2.837,5.131Zm22.832-43.289a.946.946,0,0,0-.448.113,1.017,1.017,0,0,0-.384.393l-22.821,38.835a1.076,1.076,0,0,0-.006,1.115,1.01,1.01,0,0,0,.333.362.889.889,0,0,0,.478.142h45.683a.9.9,0,0,0,.482-.132,1.046,1.046,0,0,0,.359-.4,1.062,1.062,0,0,0-.027-1.1l-22.826-38.837a.928.928,0,0,0-.823-.49Z",
    fill: "#f2163e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M180.527,284.557a2.49,2.49,0,1,1,2.49-2.49A2.492,2.492,0,0,1,180.527,284.557Zm-.1-8.951a1.149,1.149,0,0,1-1.048-1.048l-1.047-10.492a2.208,2.208,0,0,1,1.965-2.423,2.264,2.264,0,0,1,.231-.012,2.2,2.2,0,0,1,2.19,1.978,2.162,2.162,0,0,1,0,.455l-1.046,10.487a1.158,1.158,0,0,1-1.145,1.059Z",
    fill: "#f2163e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconModal);
export default __webpack_public_path__ + "static/media/ErrorIconModal.969274ee.svg";
export { ForwardRef as ReactComponent };